(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
if(!customElements.get('vb-espresso-filter')){
customElements.define('vb-espresso-filter',class extends HTMLElement{
connectedCallback(){
queueMicrotask(()=>{
if(!this.isConnected||this._abort)return;
const nav=this.querySelector('[data-vb-filter-nav]');
const items=[...this.querySelectorAll('[data-vb-product-tags]')];
if(!nav||!items.length)return;
this._abort=new AbortController();
const buttons=[...nav.querySelectorAll('[data-vb-filter]')];
nav.addEventListener('click',event=>{
const button=event.target.closest('[data-vb-filter]');
if(!button)return;
const tag=button.dataset.vbFilter;
let count=0;
items.forEach(item=>{item.hidden=!!tag&&!item.dataset.vbProductTags.split(' ').includes(tag);if(!item.hidden)count++;});
buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
this.querySelectorAll('.filters-toolbar__product-count').forEach(e=>{e.textContent=this.dataset.countTemplate.replace('__COUNT__',String(count));e.setAttribute('aria-live','polite');});
},{signal:this._abort.signal});
this.setAttribute('data-ready','');
nav.hidden=false;
});
}
disconnectedCallback(){this._abort?.abort();this._abort=null;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-blend-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var link=event.target.closest('.vbc-back');
  if(!link)return;
  var target=document.querySelector('.vb-coffee-main');
  if(target){event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-coffee-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var link=event.target.closest('.vbc-back');
  if(!link)return;
  var target=document.querySelector('.vb-coffee-main');
  if(target){event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-meteorite-info"] && !Shopify.designMode) return;
  try {
    
if(!window.vbMeteoriteDetailsReady){
  window.vbMeteoriteDetailsReady=true;
  const openMeteoriteHash=function(){
    if(!location.hash.startsWith('#meteorite-'))return;
    const detail=document.getElementById(location.hash.slice(1));
    if(detail&&detail.tagName==='DETAILS'){for(let node=detail;node;node=node.parentElement){if(node.tagName==='DETAILS')node.open=true;}}
  };
  window.addEventListener('hashchange',openMeteoriteHash);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',openMeteoriteHash,{once:true});
  else openMeteoriteHash();
  document.addEventListener('click',function(event){
    const link=event.target.closest('a[href^="#meteorite-"]');
    if(!link)return;
    const detail=document.getElementById(link.getAttribute('href').slice(1));
    if(detail&&detail.tagName==='DETAILS'){for(let node=detail;node;node=node.parentElement){if(node.tagName==='DETAILS')node.open=true;}}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-rain-info"] && !Shopify.designMode) return;
  try {
    
if(!window.vbRainDetailsReady){
  window.vbRainDetailsReady=true;
  const openRainHash=function(){
    if(!location.hash.startsWith('#rain-'))return;
    const detail=document.getElementById(location.hash.slice(1));
    if(detail&&detail.tagName==='DETAILS'){for(let node=detail;node;node=node.parentElement){if(node.tagName==='DETAILS')node.open=true;}}
  };
  window.addEventListener('hashchange',openRainHash);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',openRainHash,{once:true});
  else openRainHash();
  document.addEventListener('click',function(event){
    const link=event.target.closest('a[href^="#rain-"]');
    if(!link)return;
    const detail=document.getElementById(link.getAttribute('href').slice(1));
    if(detail&&detail.tagName==='DETAILS'){for(let node=detail;node;node=node.parentElement){if(node.tagName==='DETAILS')node.open=true;}}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-veludo-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var link=event.target.closest('.vbc-back');
  if(!link)return;
  var target=document.querySelector('.vb-coffee-main');
  if(target){event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventana-brand-world"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vb-product-carousel')){
customElements.define('vb-product-carousel',class extends HTMLElement{
connectedCallback(){
queueMicrotask(()=>{
if(!this.isConnected||this._abort)return;
const track=this.querySelector('[data-vb-track]');
const prev=this.querySelector('[data-vb-prev]');
const next=this.querySelector('[data-vb-next]');
const controls=this.querySelector('[data-vb-controls]');
if(!track||!prev||!next||!controls)return;
this._abort=new AbortController();
const signal=this._abort.signal;
const update=()=>{
const max=track.scrollWidth-track.clientWidth;
controls.hidden=max<2;
prev.disabled=track.scrollLeft<=2;
next.disabled=track.scrollLeft>=max-2;
};
const move=direction=>{
const gap=parseFloat(getComputedStyle(track).columnGap)||0;
track.scrollBy({left:direction*(track.clientWidth+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
};
prev.addEventListener('click',()=>move(-1),{signal});
next.addEventListener('click',()=>move(1),{signal});
track.addEventListener('scroll',update,{passive:true,signal});
this._resize=new ResizeObserver(update);
this._resize.observe(track);
update();
});
}
disconnectedCallback(){this._abort?.abort();this._abort=null;this._resize?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();
})();
